import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { IMarqueDtoModel } from "../models/vehicles/dto/marque-dto.model";
import { IMarqueModel } from "../models/vehicles/marque.model";
import { IModelMapping } from "./generic/model.mapping";


export class VehicleMapper implements IModelMapping<IMarqueDtoModel, IMarqueModel> {
    toApplicationModel(model: IMarqueDtoModel): IMarqueModel {
        const returnValue = {
        } as IMarqueModel;
        returnValue.marques = [];
        model.options.forEach(x => {
            returnValue.marques.push(x);
        });

        if (model.results) {
            returnValue.families = this.onlyUnique(model.results.map(x => x.range));
            returnValue.ranges =  this.onlyUnique(model.results.map(x => x.range));
            returnValue.bodyTypes =  this.onlyUnique(model.results.map(x => x.bodyType));
            returnValue.drivertrains =  this.onlyUnique(model.results.map(x => x.drivetrain));
            returnValue.engineTypes = this.onlyUnique(model.results.map(x => x.engineType));
            returnValue.engineSizes =  this.onlyUnique(model.results.map(x => x.engineSize));
            returnValue.steerings =  this.onlyUnique(model.results.map(x => x.steering));
            returnValue.transmissions =  this.onlyUnique(model.results.map(x => x.transmission));
            returnValue.variants =  this.onlyUnique(model.results.map(x => x.seriesVariant));
        }
        returnValue.vehicleSource = model.results;
        return returnValue;
    }

    onlyUnique(arr: ILookUpType[]): ILookUpType[] {
        const output: ILookUpType[] = [];
        const clone = [...arr] as ILookUpType[];
        arr.forEach(x => {
            if (x && !output.filter(o => o.id === x.id).length) {
                output.push(x);
            }
        });
        return output;
    }
    toDtoModel(model: IMarqueModel): IMarqueDtoModel {
        throw new Error("Method not implemented.");
    }
    toDtoModels(models: IMarqueModel[]): IMarqueDtoModel[] {
        throw new Error("Method not implemented.");
    }
    toApplicationModels(models: IMarqueDtoModel[]): IMarqueModel[] {
        throw new Error("Method not implemented.");
    }

}